// extracted by mini-css-extract-plugin
module.exports = {"slider":"SingleSlider_slider__5LsI9","bullet":"SingleSlider_bullet__68zlw","next":"SingleSlider_next__kpz2v","bulletActive":"SingleSlider_bulletActive__Re3Er"};